import { LiveTopic } from '../live-topics-types';
import { toTimestamp } from '@mi-front/core';

/**
 * Demo data for Live Topics when live-topics-debug=1 query param is set.
 * Original dates are mapped onto the current stream range so topics appear on the timeline.
 */
const LIVE_TOPICS_DEMO_RAW: LiveTopic[] = [
  {
    id: '5296523cbe50bc82a045714aba8dbb5c8bab2334',
    slug: 'tn-video',
    start_time: '2026-02-11T14:50:29.020000+00:00',
    end_time: '2026-02-11T15:22:49.200000+00:00',
    canonical_title: 'Protesta policial en Santa Fe',
    summary:
      'Se reporta una protesta policial en Rosario, con bloqueos en la zona del Congreso y una jefatura de policía en llamas. La protesta incluye a repartidores y otros trabajadores afectados por el bloqueo. Los policías de Santa Fe protestan por mejoras salariales y laborales, incluyendo un aumento de un millón 300 mil pesos. El conflicto incluye la quema de cubiertas y la negativa de los policías a patrullar. Policías en Rosario continúan con protestas, quemando cubiertas y negándose a patrullar. La Municipalidad de Rosario interviene con un vehículo de control. Policías protestan en la jefatura de policía, agrediendo al jefe de policía y quemando cubiertas. Los policías rechazan levantar la medida y exigen aumentos salariales y mejoras laborales. Enfermeros y maestros se suman a la protesta de policías, expresando su descontento con los bajos salarios y la inflación. Se discute la situación de policías que no recibieron la devolución de sus armas y chalecos, mientras continúa la protesta por mejoras salariales y laborales. Se menciona la participación de enfermeros en el reclamo y la negativa de los policías a levantar la medida. Los policías de Santa Fe protestan contra el gobierno, rechazando la cobertura mediática y exigiendo mejoras salariales y laborales. El conflicto incluye agresiones a periodistas y la negativa de los policías a patrullar. El ministro de Seguridad de Santa Fe reconoce el conflicto y solicita a los policías que se reintegren al servicio ordinario. Se menciona que los reclamos son sobre mejoras salariales y de bienestar para el personal de seguridad.',
    category: 'Seguridad & Justicia',
    key_points: [
      'Protesta policial en Rosario con bloqueos en el Congreso',
      'Jefatura de policía en llamas en avenida Lagos',
      'Protesta activa hace más de 48 horas',
      'Bloqueo afecta a repartidores y otros trabajadores',
      'Protesta policial en la jefatura de policía de Santa Fe',
      'Reclamo por aumento salarial y mejoras laborales',
      'Quema de cubiertas en la puerta de la jefatura',
      'Negativa de los policías a patrullar',
      'Propuesta del gobierno de 1.3 millones de pesos',
      'Ministro de Seguridad reconoce el fondo del reclamo',
      'Policías protestan en la jefatura de policía de Rosario',
      'Se queman cubiertas en la puerta del edificio',
      'Policías entran y salen del edificio',
      'La Municipalidad de Rosario interviene con un vehículo de control',
      'Se menciona que los policías descartaron levantar la medida',
      'Policías agredieron al jefe de policía con escupitajos',
      'Se quemaron cubiertas en la puerta de la jefatura',
      'Los policías rechazan levantar la medida',
      'Exigen aumentos salariales y mejoras laborales',
      'Enfermeros se suman a la protesta',
      'Maestros también están reclamando',
      'Salarios no alcanzan para cubrir necesidades básicas',
      'Alquileres muy elevados',
      'Policías no recibieron devolución de armas y chalecos',
      'Protesta por aumento salarial y mejoras laborales',
      'Enfermeros se suman al reclamo',
      'Ministro de Seguridad reconoce el fondo del reclamo',
      'Continúan las quemas de cubiertas en la jefatura policial',
      'Los policías protestan en cadena nacional',
      'Se rechaza la cobertura mediática',
      'Se exige un aumento salarial',
      'Se reportan agresiones a periodistas',
      'Los policías no salen a patrullar',
      'Se reconoce un conflicto en la Policía de Santa Fe',
      'Se solicita el regreso inmediato al servicio ordinario',
      'Los reclamos son sobre mejoras salariales y bienestar',
      'Se destaca el esfuerzo de la policía en la lucha contra el narcotráfico',
    ],
    entities: {
      people: ['Dolores', 'Laura', 'Luis Maldonado', 'Pablo Cocochoni'],
      orgs: [
        'Maestros',
        'Fuerzas de Seguridad de Santa Fe',
        'Policía Federal',
        'Policía de la Ciudad',
        'Ministerio de Seguridad de Santa Fe',
        'Enfermeros',
        'Policía de Santa Fe',
        'Ministerio de Economía de Santa Fe',
        'Jefatura de Policía',
        'Municipalidad de Rosario',
        'Jefatura de la Policía',
      ],
      places: ['avenida Lagos', 'Santa Fe', 'Jefatura de la Policía', 'Rosario'],
      events: [
        'Protesta',
        'protesta policial',
        'Protesta policial',
        'bloqueo',
        'incendio',
        'Quema de cubiertas',
        'Negociaciones salariales',
        'Agresiones a periodistas',
      ],
    },
    associated_to: '69d06877d8f5db221defffaa09bbc00a15d8b49b',
    is_refined: false,
    is_open: false,
  },
  {
    id: '75255ba889ea31e1e2667008f69b2d269ca50821',
    slug: 'tn-video',
    start_time: '2026-02-11T14:42:28+00:00',
    end_time: '2026-02-11T14:50:02.550000+00:00',
    canonical_title: 'Marchas contra reforma laboral',
    summary:
      'Marchas y protestas en el Congreso de la Nación contra la reforma laboral. El área está vallada y el tránsito está restringido, con movilizaciones previstas para la tarde. Trabajadores y comercios en la zona enfrentan una movilización contra la reforma laboral. La policía ha establecido un fuerte operativo de seguridad.',
    category: 'Política',
    key_points: [
      'Congreso vallado y con restricciones de tránsito',
      'Marchas previstas para la tarde',
      'Presencia de banderas de movimientos sociales y gremios',
      'Protocolo antipiquetes aplicado',
      'Trabajadores reclaman sus derechos en una movilización',
      'Comercios reportan bajo movimiento debido a la protesta',
      'El operativo policial es más extenso que en protestas anteriores',
      'Algunos comercios permanecen cerrados por la protesta',
    ],
    entities: {
      people: [],
      orgs: ['Senado', 'CGT', 'gobierno'],
      places: ['Congreso de la Nación', 'Rivadavia', 'Corrientes', 'Avenida Callao'],
      events: ['reforma laboral', 'operativo policial', 'marcha'],
    },
    associated_to: null,
    is_refined: false,
    is_open: false,
  },
  {
    id: '69d06877d8f5db221defffaa09bbc00a15d8b49b',
    slug: 'tn-video',
    start_time: '2026-02-11T14:40:58+00:00',
    end_time: '2026-02-11T14:42:11.020000+00:00',
    canonical_title: 'Protesta policial en Santa Fe',
    summary:
      'Policías en Santa Fe protestan por mejoras salariales y condiciones laborales. El gobierno propone un aumento que equipara el salario con la canasta básica, pero los policías exigen un decreto que garantice no ser sancionados por protestar.',
    category: 'Seguridad & Justicia',
    key_points: [
      'Protesta de policías en Santa Fe',
      'Propuesta de aumento salarial a 1.300.000 pesos',
      'Exigencia de decreto para no sancionar a manifestantes',
      'Se levantaron pases a disponibilidad de agentes sancionados',
    ],
    entities: {
      orgs: ['gobierno de la provincia de Santa Fe'],
      places: ['Santa Fe'],
    },
    associated_to: '3f3058411f6e23e9208df0f01bf6720b19b47e32',
    is_refined: false,
    is_open: false,
  },
  {
    id: '3f3058411f6e23e9208df0f01bf6720b19b47e32',
    slug: 'tn-video',
    start_time: '2026-02-11T14:22:22.720000+00:00',
    end_time: '2026-02-11T14:37:53.770000+00:00',
    canonical_title: 'Aumento salarial para personal policial en Santa Fe',
    summary:
      "Se discute un aumento salarial para personal policial en Santa Fe, con una base solicitada de $1.3 millones. Los policías esperan un decreto concreto para levantar la protesta. Se discuten las negociaciones entre el personal policial y el gobierno provincial sobre un aumento salarial de $1.300.000, con la condición de que la propuesta se presente por escrito. Policías de Santa Fe protestan en la jefatura, rechazando un aumento salarial propuesto y exigiendo mejoras laborales. El ministro de Seguridad reconoce el reclamo, pero la protesta continúa con incidentes como empujones al jefe de policía y quema de cubiertas. Protestantes en Santa Fe enfrentan a la policía, con el jefe de policía Luis Maldonado siendo agredido. Se menciona que el grupo es 'minúsculo' pero crece, y que no hay acuerdos inmediatos.",
    category: 'Seguridad & Justicia',
    key_points: [
      'Se solicita un salario base de $1.3 millones de la canasta básica',
      'Los policías esperan un decreto concreto para levantar la protesta',
      'Se discute la implementación de medidas para salud mental',
      'El gobierno promete solucionar la situación a la brevedad',
      'Los policías exigen un aumento salarial de $1.300.000',
      'Se requiere que la propuesta se presente por escrito',
      'El personal policial está en disposición de levantar la protesta si se cumple la oferta',
      'Se menciona la situación del sector docente en paritarias',
      'Protesta en la jefatura de policía de Santa Fe',
      'Rechazo a un aumento salarial propuesto',
      'Exigencia de mejoras en condiciones laborales',
      'Ministro de Seguridad reconoce el reclamo',
      'Incidentes incluyen empujones al jefe de policía',
      'Quema de cubiertas en la entrada de la jefatura',
      'Protesta en Santa Fe con llegada de más policías',
      'Jefe de policía Luis Maldonado agredido',
      "Ministro califica a manifestantes como 'grupo minúsculo'",
      'No hay acuerdos inmediatos',
      'Cadena de mando cortada',
    ],
    entities: {
      people: ['Luis Maldonado'],
      orgs: ['Policía de Santa Fe', 'policía de Santa Fe', 'Ministerio de Seguridad de Santa Fe'],
      places: ['Unidad Regional Número 2', 'Jefatura de Policía', 'Santa Fe', 'Rosario'],
      events: [
        'Protesta policial',
        'protesta policial',
        'paritarias docentes',
        'Negociación salarial',
      ],
    },
    associated_to: '3143c862f61a6c6a62a3b5359934d4151703403f',
    is_refined: false,
    is_open: false,
  },
  {
    id: '3143c862f61a6c6a62a3b5359934d4151703403f',
    slug: 'tn-video',
    start_time: '2026-02-11T14:11:58.940000+00:00',
    end_time: '2026-02-11T14:19:28+00:00',
    canonical_title: 'Aumento salarial para personal policial en Santa Fe',
    summary:
      'Los policías de Santa Fe continúan protestando por mejoras salariales y laborales. El gobierno propuso equiparar el salario mínimo inicial con la canasta básica y mejorar condiciones de trabajo. Los policías de Santa Fe continúan con su protesta, con vehículos en estado impecable y sin presencia policial en las calles. Se espera que haya definiciones en cualquier momento.',
    category: 'Seguridad & Justicia',
    key_points: [
      'Los policías mantienen la protesta',
      'Se realizan reuniones con jefes de tercios',
      'Se propone equiparar salario con canasta básica',
      'Se discuten mejoras en condiciones laborales',
      'Se menciona reinterporación de 20 efectivos',
      'Protesta policial con vehículos en estado impecable',
      'Falta de presencia policial en las calles',
      'Se espera definiciones en la semana',
      'Se menciona a Sebastián Izquierdo como representante de los reclamos',
    ],
    entities: {
      people: ['Sebastián Izquierdo', 'Gabriel Sarla', 'Luis Maldonado'],
      orgs: [
        'Ministerio de Hacienda y Economía de Santa Fe',
        'Ministerio de Seguridad de Santa Fe',
        'Ministerio de Economía de Santa Fe',
      ],
      places: ['Jefatura de Policía', 'Santa Fe', 'Rosario'],
      events: ['Reunión con autoridades', 'Protesta policial'],
    },
    associated_to: '7e6a3040f91bab8ec9510e9d65513803fde87c05',
    is_refined: false,
    is_open: false,
  },
  {
    id: 'ec159a4f8bf4253b0cabbb010ab364681576ce29',
    slug: 'tn-video',
    start_time: '2026-02-11T14:08:28.780000+00:00',
    end_time: '2026-02-11T14:11:33.860000+00:00',
    canonical_title: 'Sesión del Senado para reforma laboral',
    summary:
      'Se describe el inicio de la sesión en el Senado para la reforma laboral, con la presencia de Patricia Bullrich y la necesidad de 37 senadores para alcanzar el quórum. Se menciona que la sesión será larga, con discusiones y votaciones que podrían extenderse hasta la madrugada. El Senado debate una reforma laboral con oradores como Santilli, Milei y Menem. El gobierno necesita 37 votos para la mayoría simple y hubo 28 modificaciones negociadas con bloques aliados y mandatarios provinciales.',
    category: 'Política',
    key_points: [
      'Se requieren 37 senadores para iniciar la sesión',
      'Patricia Bullrich lidera la sesión',
      'La votación podría extenderse hasta la madrugada',
      'Se esperan 28 modificaciones negociadas con bloques aliados',
      'El peronismo aún no ha definido si participará en la sesión',
      'La sesión será larga con múltiples oradores',
      'Se necesita mayoría simple (37 votos)',
      'Hubo 28 modificaciones negociadas',
      'El tema de ganancias fue modificado',
      'El radicalismo y PRO aportarán votos aliados',
    ],
    entities: {
      people: [
        'Patricia Burrich',
        'Lule Menem',
        'senador Mayanz',
        'Karina Milei',
        'Diego Santín',
        'Diego Santilli',
        'Patricia Bullrich',
        'Martín Menem',
      ],
      orgs: ['Senado', 'Senado de la Nación'],
      places: [],
      events: ['sesión de reforma laboral', 'Sesión del Senado'],
    },
    associated_to: '93a468c08dcaf814427770bb31d5cb7ab635100a',
    is_refined: false,
    is_open: false,
  },
];

/**
 * Maps demo topics onto the current stream range so they appear on the timeline.
 * Preserves relative positions and durations from the original demo span.
 */
export function getLiveTopicsDemoMappedToRange(range: { from: number; to: number }): LiveTopic[] {
  if (LIVE_TOPICS_DEMO_RAW.length === 0) {
    return [];
  }

  const demoStarts = LIVE_TOPICS_DEMO_RAW.map((t) => toTimestamp(t.start_time));
  const demoEnds = LIVE_TOPICS_DEMO_RAW.map((t) => toTimestamp(t.end_time));
  const demoMin = Math.min(...demoStarts);
  const demoMax = Math.max(...demoEnds);
  const demoSpan = demoMax - demoMin;
  const rangeSpan = range.to - range.from;

  if (demoSpan <= 0 || rangeSpan <= 0) {
    return LIVE_TOPICS_DEMO_RAW;
  }

  return LIVE_TOPICS_DEMO_RAW.map((topic) => {
    const startTs = range.from + ((toTimestamp(topic.start_time) - demoMin) / demoSpan) * rangeSpan;
    const endTs = range.from + ((toTimestamp(topic.end_time) - demoMin) / demoSpan) * rangeSpan;
    return {
      ...topic,
      start_time: new Date(startTs).toISOString(),
      end_time: new Date(endTs).toISOString(),
    };
  });
}
